import { createSelector } from 'reselect';
import { connect } from 'react-redux';
import FrameworkUtils from 'utils/framework';
import { userSelector } from 'selectors/user/userSelector';
import { authSelector } from 'selectors/auth/authSelector';
import basketSelector from 'selectors/basket/basketSelector';
import BeautyInsiderSelector from 'selectors/beautyInsider/beautyInsiderSelector';
import userUtils from 'utils/User';
import localeUtils from 'utils/LanguageLocale';
import BeautyInsiderAllRewardsEN from 'components/Content/BeautyInsider/BeautyInsiderAllRewards/locales/BeautyInsiderAllRewards_en_US';
import BeautyInsiderAllRewardsFR from 'components/Content/BeautyInsider/BeautyInsiderAllRewards/locales/BeautyInsiderAllRewards_fr_CA';

const { wrapHOC } = FrameworkUtils;
const { beautyInsiderSelector } = BeautyInsiderSelector;

const getText = localeUtils.getLocalisedDataFromResource(BeautyInsiderAllRewardsEN, BeautyInsiderAllRewardsFR);

const fields = createSelector(userSelector, authSelector, basketSelector, beautyInsiderSelector, (user, auth, basket, beautyInsider) => {
    return {
        isAnonymous: user.isInitialized && userUtils.isAnonymous(),
        user,
        auth,
        basket,
        biRewardGroups: beautyInsider.biRewardGroups || {},
        localization: {
            allRewards: getText('allRewards'),
            addFullSize: getText('addFullSize'),
            rougeBadge: getText('rougeBadge'),
            freeShipping: getText('freeShipping')
        }
    };
});

const functions = () => ({});

const withBeautyInsiderAllRewardsProps = wrapHOC(connect(fields, functions));

export {
    withBeautyInsiderAllRewardsProps, fields, functions
};
